var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"px-0",class:_vm.componentClass,attrs:{"title":"condividi","variant":"link"},on:{"click":function($event){return _vm.toggleShareModal()}}},[_c('b-icon',{attrs:{"icon":"share","font-scale":"1.2","aria-label":"condividi"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }